import { FC } from 'react'
import { useIntl } from 'react-intl'
import Dashboard from 'layouts/Dashboard'
import DesktopNavigation from 'components/DesktopNavigation'
import InsuranceConsent from 'components/InsuranceConsent'
import { UserProtectedRoute } from 'routes'

const InsuranceConsentPage: FC = () => {
  const { formatMessage } = useIntl()

  return (
    <UserProtectedRoute>
      <Dashboard>
        <DesktopNavigation
          label={formatMessage({
            id: 'insuranceConsent.title',
            defaultMessage: 'Potwierdzenie zgody na ubezpieczenie'
          })}
          desktopNavigateTo='/'
        />
        <InsuranceConsent />
      </Dashboard>
    </UserProtectedRoute>
  )
}

export default InsuranceConsentPage
